import { TokenType } from "@/config/token-types";

export const getMethGeneration = (token) => {
  const tokenType = token.type;
  if (tokenType === TokenType.GENESIS) return 20;
  if (tokenType === TokenType.GOD) return 100;
  if (tokenType === TokenType.TEEN && token.isResurrected && !token.isBurned) return 7;
};
